// extracted by mini-css-extract-plugin
export var customerMissing = "customer-missing-module--customerMissing--+60CJ";
export var customerMissingMessage = "customer-missing-module--customerMissingMessage--GShj9";